'use strict';
const Motors = require('../../../sdk/resources/bepensa/Motors');
var actionTypes = require('../actionTypes');

const CF_MOTOR_CODE = process.env.CF_MOTOR;
const CF_CPL_CODE = process.env.CF_CPL;
const CF_PARTCODE_CODE = process.env.CF_PART_NUMBER;
const CF_MARCA_CODE = process.env.CF_MARCA;
const CF_PREDECESSOR_CODE = process.env.CF_ANTECESOR;
const CF_SUPERCESSOR_CODE = process.env.CF_SUPERCESOR;
const CF_CORE_CODE = process.env.CF_CORE_CODE;
const CF_PART_RELATIONS = process.env.CF_RELATED_PART;
const CF_CORE_PRICE = process.env.CF_CORE_PRICE;
const CF_LTA = process.env.CF_LTA;
const CF_UNIT_SALE = process.env.CF_SALES_UNIT;
const CF_CURRENCY = process.env.CF_CURRENCY;

const initialState = {
    itemModel: {
        categories: [],
        categoriesSelected: [],
        categoryWord: '',
        listingName: '',
        description: '',
        images: [],
        customFields: [],
        shippingModel: null,
        currencyCode: '',
        bulkPricing: [],
        shipping: [],
        moqCode: null,
        bulkPricingCode: null,
        countryCode: null,
        pricing: null,
        selectedVariant: null,
        ReviewAndRating: '',
        price: "",
        quantity: "",
        sku: "",
        isUnlimitedStock: false,
        hasVariants: false,
        variantGroups: [],
        itemVariants: [],
        savedItemVariants: [],
        selectedVariant: null,
        locationItems: [],
        locations: [],
        selectedLocationIds: [],
        savedChildItemIds: [],
        itemHeigth: 0,
        itemHeightUnit: "",
        itemLength: 0,
        itemLengthUnit: "",
        itemWidth: 0,
        itemWidthUnit: "",
        itemWeigth: 0,
        itemWeigthUnit: "",
        itemSearchable: false,
        customFieldsValues: {
            codigoCore: {
                "code": CF_CORE_CODE,
                "value": ""
            },
            precioCore: {
                "code": CF_CORE_PRICE,
                "value": ""
            },
            numPart: {
                "code": CF_PARTCODE_CODE,
                "value": ""
            },
            antecesor: {
                "code": CF_PREDECESSOR_CODE,
                "value": ""
            },
            supercesor: {
                "code": CF_SUPERCESSOR_CODE,
                "value": ""
            },
            relatedParts: {
                "code": CF_PART_RELATIONS,
                "value": ""
            },
            unitSale: {
                "code": CF_UNIT_SALE,
                "value": ""
            },
            lta: {
                "code": CF_LTA,
                "value": false
            },
            _marca: {
                "code": CF_MARCA_CODE,
                "value": ""
            },
            _motor: {
                "code": CF_MOTOR_CODE,
                "value": ""
            },
            cpl: {
                "code": CF_CPL_CODE,
                "value": ""
            },
            currency: {
                "code": CF_CURRENCY,
                "value": ""
            }
        }
    },
    motors: []


};

function uploadEditItemReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.UPDATE_ITEM_UPLOAD_EDIT_CATEGORIES_TO_SEARCH: {
            return Object.assign({}, state, {
                itemModel: action.itemModel,
                motors: action.motors
            });
        }
        case actionTypes.ITEM_UPLOAD_EDIT_SELECT_UNSELECT_CATEGORY: {
            return Object.assign({}, state, {
                itemModel: action.itemModel,
                motors: action.motors
            });
        }
        case actionTypes.UPDATE_LISTING_NAME: {
            return Object.assign({}, state, {
                itemModel: action.itemModel,
                motors: action.motors
            });
        }
        case actionTypes.ITEM_UPLOAD_EDIT_UPDATE_DATA: {
            return Object.assign({}, state, {
                itemModel: action.itemModel,
                motors: action.motors
            });
        }
        case actionTypes.ITEM_UPLOAD_EDIT_GET_CUSTOMFIELDS: {
            return Object.assign({}, state, {
                itemModel: action.itemModel,
                motors: action.motors
            });

        }
        case actionTypes.ITEM_UPLOAD_EDIT_MODAL_CHANGE: {
            return Object.assign({}, state, {
                itemModel: action.itemModel,
                modalStatus: action.modalStatus,
                motors: action.motors
            });
        }
        case actionTypes.CREATE_CUSTOM_FIELD: {
            return Object.assign({}, state, {
                itemModel: action.itemModel,
                motors: action.motors
            });
        }

        default:
            return state;
    }
}

module.exports = {
    uploadEditItemReducer: uploadEditItemReducer
};
